import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Stepper from '../Stepper/Stepper';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('QuantityStepper');

class QuantityStepper extends PureComponent {
    constructor(props) {
        super(props);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.state = {
            quantity: this.props.initialQuantity,
        };
    }

    componentDidUpdate(prevProps) {
        const { initialQuantity, shouldReset } = this.props;
        const initialQuantityChanged = initialQuantity !== prevProps.initialQuantity;
        const reset = !!shouldReset && !prevProps.shouldReset;

        if (initialQuantityChanged || reset) {
            this.resetQuantity();
        }
    }

    resetQuantity = () => {
        this.setState({ quantity: this.props.initialQuantity });
    };

    render() {
        const { className, minQuantity, maxQuantity, orientation, messages, disabled } = this.props;
        return (
            <div className={bem(null, null, className)}>
                <Stepper
                    onChange={this.onQuantityChange}
                    min={minQuantity}
                    max={maxQuantity}
                    orientation={orientation}
                    stepperValue={this.state.quantity}
                    messages={messages}
                    disabled={disabled}
                />
            </div>
        );
    }

    onQuantityChange(newQuantity) {
        this.setState({ quantity: newQuantity });
        this.props.onChange?.(newQuantity);
    }
}

QuantityStepper.propTypes = {
    minQuantity: PropTypes.number,
    maxQuantity: PropTypes.number,
    initialQuantity: PropTypes.number.isRequired,
    orientation: PropTypes.string,
    className: PropTypes.string,
    messages: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    shouldReset: PropTypes.bool,
};

QuantityStepper.defaultProps = {
    minQuantity: 1,
    maxQuantity: Number.MAX_SAFE_INTEGER,
    orientation: 'horizontal',
    initialQuantity: 1,
    disabled: false,
    shouldReset: false,
};

export default QuantityStepper;
